import styled, { css } from 'styled-components';
import { colorVariables, mediaTemplates } from 'desktop/theme/variables';
import Text from 'desktop/components/Text';
import Scrollbar from 'desktop/components/Scrollbar';

export const DailyProgramStyled = styled.div`
  position: relative;
  width: calc(100% - 410px);
  height: 100%;
  overflow: hidden;
  transition: 275ms linear;
`;

export const DailyContent = styled.div`
  height: 100%;
  width: 100%;
  visibility: hidden;

  ${(props) =>
    props.visible &&
    css`
      visibility: visible;
    `};
`;

export const DaysContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`;

export const NoPrograms = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  z-index: 1;
`;

export const NoProgramsImage = styled.img`
  width: 110px;
  height: 110px;
  opacity: 0.5;
`;

export const DateHeaderCapStyled = styled.div`
  ${(props) =>
    props &&
    css`
      height: ${props.isHidden ? 0 : 75}px !important;
    `};
`;

export const CapSeparator = styled.span`
  display: block;
  width: calc(100% - 210px);
  height: 1px;
  background-color: ${colorVariables.gray_darkmetal};
  position: absolute;
  top: 50%;
  left: 50px;
  z-index: 1;

  ${mediaTemplates.s} {
    display: none;
  }
`;

export const StyledText = styled(Text)`
  && {
    font-size: 18px;
    text-align: center;
    width: 320px;
  }
`;

export const StyledScrollbar = styled(Scrollbar)`
  && {
    width: calc(100% - 50px);
    padding-right: 50px;
  }
`;

export const AbsoluteWrapperStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  z-index: 2;
`;
